import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, FormControl, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { Location } from '@angular/common';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';

@Component({
	selector: 'app-vendor-create',
	templateUrl: './vendor-create.component.html',
	styleUrls: ['./vendor-create.component.scss']
})
export class VendorCreateComponent implements OnInit, AfterViewInit {

	vd: any = {};
	banking = true;
	files: any[] = [];
	taxes: any[] = [];
	currencies: any[] = [];
	bankaccounts: any[] = [];
	types: any = {};
	zones: any = {};
	paymentterms: any[] = [];
	vendorForm: any = false;
	active_vendors: any[] = [];
	supplieridManuallyEdited = false;
	color = '';

	defaults: any = {};

	constructor(
		private route: ActivatedRoute,
		private vendorService: VendorService,
		private location: Location,
		public router: Router,
		private globalSearchService: GlobalSearchService,
		private fb: UntypedFormBuilder,
		public globalsService: GlobalsService
	) {
		this.color = this.globalSearchService.getColor();
	}

	get billingStepValid(): boolean {
		const required = ['supplierid', 'suppname', 'address1', 'address3', 'address4', 'address5', 'address6'];
		return required.every(c => this.vendorForm.get(c)?.valid);
	}

	ngOnInit(): void {
		if (this.globalsService.config?.defaults) {
			this.defaults = { ...this.defaults, ...this.globalsService.config.defaults };
		}

		this.vendorService.getVendors().subscribe((r: any) => {
			this.active_vendors = r;
		});

		this.vendorForm = this.fb.group({
			supplierid: ['', [Validators.required, this.vendIdExists()]],
			suppname: ['', [Validators.required]],
			email: ['', [Validators.required]],
			address1: ['', [Validators.required]],
			address2: ['', []],
			address3: ['', [Validators.required]],
			address4: [this.defaults.region || '', [Validators.required]],
			address5: ['', [Validators.required]],
			address6: [this.defaults.country || '', [Validators.required]],
			supptype: [this.defaults.suppliertype || '', [Validators.required]],
			currcode: [this.defaults.currency || '', [Validators.required]],
			paymentterms: [this.defaults.terms || '', [Validators.required]],
			bankact: [this.defaults.bank || '', [Validators.required]],
			remittance: [this.defaults.remit || '', [Validators.required]],
			taxgroupid: [this.defaults.taxauth || '', [Validators.required]],
			factorcompanyid: [''],
			telephone: ['', [Validators.required]],
			url: ['']
		});

		this.vendorForm.get('suppname').valueChanges.subscribe((name: string) => {
			if (name && !this.supplieridManuallyEdited) {
				this.vendorForm.get('supplierid').setValue(this.generateVendorId(name), { emitEvent: false });
			}
		});

		this.vendorForm.get('supplierid').valueChanges.subscribe(() => {
			if (this.vendorForm.get('supplierid').dirty) {
				this.supplieridManuallyEdited = true;
			}
		});

		this.applyVendorContactRequiredFromConfig();

		this.globalSearchService.configsubscription.subscribe(c => {
			if (c?.defaults) {
				this.defaults = { ...this.defaults, ...c.defaults };
				this.vendorForm?.get('taxgroupid')?.setValue(this.defaults.taxauth, { emitEvent: false });
			}
			this.applyVendorContactRequiredFromConfig();
		});

		this.banking = this.globalsService.config?.vendorRequireBankingInfo ?? false;
		if (this.banking) {
			const extras: { [key: string]: FormControl } = {
				sin: new FormControl('', [Validators.required]),
				bn: new FormControl('', [Validators.required]),
				bankbeneficiary: new FormControl('', [Validators.required]),
				bankname: new FormControl('', [Validators.required]),
				bankaddress1: new FormControl('', [Validators.required]),
				bankaddress2: new FormControl(''),
				bankaddress3: new FormControl('', [Validators.required]),
				bankaddress4: new FormControl('', [Validators.required]),
				bankaddress5: new FormControl('', [Validators.required]),
				bankaddress6: new FormControl('', [Validators.required]),
				bankaccountno: new FormControl('', [Validators.required]),
				iban: new FormControl('', [Validators.required]),
				banktransitno: new FormControl('', [Validators.required]),
				bankcurrencypref: new FormControl('', [Validators.required]),
				bankswiftcode: new FormControl('', [Validators.required]),
			};

			Object.keys(extras).forEach(key => this.vendorForm.addControl(key, extras[key]));
			this.vendorForm.updateValueAndValidity();

			this.vendorForm.get('bankaddress6').valueChanges.subscribe((val: string) => {
				if (val.toLowerCase().includes('canada')) {
					this.vendorForm.get('bankcurrencypref').setValue('CAD');
				} else if (val.toLowerCase().includes('united states')) {
					this.vendorForm.get('bankcurrencypref').setValue('USD');
				}
				this.vendorForm.get('bankcurrencypref').updateValueAndValidity();
			})


			//either bn or sin
			this.vendorForm.get('bn').valueChanges.subscribe((newv: any) => {
				const sin = this.vendorForm.get('sin');
				if (newv?.length) {
				  sin.clearValidators();
				} else {
				  sin.setValidators([Validators.required]);
				}
				sin.updateValueAndValidity({ emitEvent: false });
			  });
			  
			  this.vendorForm.get('sin').valueChanges.subscribe((newv: any) => {
				const bn = this.vendorForm.get('bn');
				if (newv?.length) {
				  bn.clearValidators();
				} else {
				  bn.setValidators([Validators.required]);
				}
				bn.updateValueAndValidity({ emitEvent: false });
			  });


			//either bankaccountno or iban
			this.vendorForm.get('bankaccountno').valueChanges.subscribe((newv: any) => {
				const iban = this.vendorForm.get('iban');
				if (newv?.length) {
				  iban.clearValidators();
				} else {
				  iban.setValidators([Validators.required]);
				}
				iban.updateValueAndValidity({ emitEvent: false });
			  });
			  
			  this.vendorForm.get('iban').valueChanges.subscribe((newv: any) => {
				const bank = this.vendorForm.get('bankaccountno');
				if (newv?.length) {
				  bank.clearValidators();
				} else {
				  bank.setValidators([Validators.required]);
				}
				bank.updateValueAndValidity({ emitEvent: false });
			  });

		}
	}

	ngAfterViewInit(): void {
		this.globalsService.getTypes().subscribe(details => { this.types = details; });
		this.globalsService.getBankAccounts().subscribe(details => { this.bankaccounts = details; });
		this.globalsService.getTerms().subscribe(details => { this.paymentterms = details; });
		this.globalsService.getTaxes().subscribe(details => { this.taxes = details; });
		this.globalsService.getCurrencies().subscribe(details => { this.currencies = details; });
		this.globalsService.getDefaultZones().subscribe(details => { this.zones = details; });
	}

	private applyVendorContactRequiredFromConfig(): void {
		if (!this.vendorForm || typeof this.vendorForm.get !== 'function') return;
		const required = !!this.globalsService.config?.vendorRequireEmailPhone;
		const email = this.vendorForm.get('email');
		if (email) {
			email.setValidators(required ? [Validators.required] : []);
			email.updateValueAndValidity();
		}
	}

	onSelect(event: any): void {
		event.addedFiles.forEach((file: File) => {
			this.readFile(file).then(content => {
				this.files.push({ name: file.name, type: file.type, content });
			});
		});
	}

	onRemove(file: any): void {
		this.files.splice(this.files.indexOf(file), 1);
	}

	private readFile(file: File): Promise<string | ArrayBuffer> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = e => resolve((e.target as FileReader).result);
			reader.onerror = () => reject(null);
			if (!file) return reject(null);
			reader.readAsDataURL(file);
		});
	}

	updateVendor(): void {
		if (this.vendorForm.valid) {
			this.vendorService.saveVendor(this.vendorForm.value).subscribe({
				next: () => {
					this.router.navigate(['vendors/' + this.vendorForm.controls.supplierid.value]);
				},
				error: (error: any) => {
					const msg = error?.error?.message || error?.message || 'Error saving vendor';
					const isDuplicate = /duplicate|already exists|supplierid|unique constraint/i.test(msg);
					if (isDuplicate) {
						this.vendorForm.get('supplierid').setErrors({ duplicate: true });
					}
					this.globalSearchService.showNotification(
						isDuplicate ? 'Vendor ID already exists. Please choose a different ID.' : msg,
						'danger', 'bottom', 'right'
					);
				}
			});
		} else {
			this.getFormValidationErrors();
		}
	}

	back(): void {
		this.location.back();
	}

	updateZones(value: any): void {
		if (value?.value) {
			const country = this.zones.countries.find((c: any) => c.name === value.value);
			if (country) {
				this.globalsService.getCountryZones(country.country_id).subscribe((details: any) => {
					this.zones.zones = details.zone;
				});
			}
		}
	}

	getAddress(place: any, bank: any = false): void {
		const components = place['address_components'];
		const prefix = bank ? 'bank' : '';

		this.vendorForm.get(`${prefix}address1`).setValue(this.parseComponentShortName(components, ['street_number', 'route']));
		this.vendorForm.get(`${prefix}address2`).setValue(this.parseComponentShortName(components, ['subpremise']));
		this.vendorForm.get(`${prefix}address3`).setValue(this.parseComponentShortName(components, ['locality']));
		this.vendorForm.get(`${prefix}address4`).setValue(this.parseComponentShortName(components, ['administrative_area_level_1']));
		this.vendorForm.get(`${prefix}address5`).setValue(this.parseComponentShortName(components, ['postal_code']));
		this.vendorForm.get(`${prefix}address6`).setValue(this.parseComponentLongName(components, ['country']));

		if (bank) return;

		if (place['name']) {
			this.vendorForm.get('suppname').setValue(place['name']);
			if (!this.supplieridManuallyEdited) {
				this.vendorForm.get('supplierid').setValue(this.generateVendorId(place['name']));
			}
		}
		if (place['formatted_phone_number']) {
			this.vendorForm.get('telephone').setValue(place['formatted_phone_number']);
		}
		if (place['website']) {
			this.vendorForm.get('url').setValue(place['website']);
		}
	}

	getFormValidationErrors(): void {
		this.vendorForm.markAllAsTouched();
		Object.keys(this.vendorForm.controls).forEach(key => {
			const errors: ValidationErrors = this.vendorForm.get(key).errors;
			if (errors) {
				Object.keys(errors).forEach(errorKey => {
					this.globalSearchService.showNotification(`${key} ${errorKey}`, 'danger', 'bottom', 'right');
				});
			}
		});
	}

	private vendIdExists(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value?.toUpperCase();
			if (!value) return null;
			return this.active_vendors.some(v => v.supplierid.toUpperCase() === value) ? { isNewvendor: true } : null;
		};
	}

	private parseComponentShortName(components: any[], types: string[]): string {
		const result: string[] = [];
		components.forEach(comp => {
			comp.types.forEach((local: string) => {
				if (types.includes(local) && comp.short_name) {
					result.push(comp.short_name);
				}
			});
		});
		return result.join(' ');
	}

	private parseComponentLongName(components: any[], types: string[]): string {
		const result: string[] = [];
		components.forEach(comp => {
			comp.types.forEach((local: string) => {
				if (types.includes(local) && comp.long_name) {
					result.push(comp.long_name);
				}
			});
		});
		return result.join(' ');
	}

	private generateVendorId(name: string): string {
		if (!name) return '';

		const cleanName = name
			.replace(/\s+(Inc|LLC|Ltd|Corp|Corporation|Company|Co)(\.)?$/i, '')
			.trim();

		let id = cleanName.split(' ').filter(w => w.length).map(w => w[0].toUpperCase()).join('');

		if (id.length < 3) {
			id = cleanName.split(' ').map(w => w.substring(0, 2).toUpperCase()).join('').substring(0, 6);
		}

		id = id.substring(0, 10);

		if (id.length < 3) {
			id = cleanName.replace(/\s/g, '').substring(0, 10).toUpperCase();
		}

		const existingIds = this.active_vendors?.map((v: any) => v.supplierid.toUpperCase()) || [];
		let uniqueId = id;
		let counter = 1;

		while (existingIds.includes(uniqueId.toUpperCase()) && counter < 1000) {
			const suffix = counter.toString();
			uniqueId = id.substring(0, 10 - suffix.length) + suffix;
			counter++;
		}

		return uniqueId;
	}
}
